<div class="modal-content" cdkTrapFocus [cdkTrapFocusAutoCapture]="false" role="dialog" [attr.aria-labelledby]="'my-modal-title'" aria-describedby="verify-identity-description">
  <div class="modal-header">
    <h1 id="my-modal-title" class="modal-title pull-left">{{ 'RIDP_TITLE' | globalTranslate }}</h1>
  </div>
  <div class="card-background modal-body">
    <div class="verify-identity-container">
      <div class="user-icon" role="img" aria-label="User identity icon">
            <img aria-hidden="true" src="assets/images/Icons/people_outline.svg" alt="" />
      </div>
      <h2 class="verification-status">{{ 'RIDP_VERIFY_IDENTITY_POPUP_TEXT_01' | globalTranslate }}</h2>
      <p id="verify-identity-description" class="verification-description">{{ 'RIDP_VERIFY_IDENTITY_POPUP_TEXT_02' | globalTranslate }}</p>
      <ul class="benefits-list" role="list" aria-label="Benefits of identity verification">
        <li class="benefit-item">
          <div class="benefit-icon" aria-hidden="true">
            <img src="assets/images/Icons/hearts.svg" alt="" />
          </div>
          <span class="benefit-text">{{'IDVERIFY_BENEFITS_01' | globalTranslate}}</span>
        </li>
        <li class="benefit-item">
          <div class="benefit-icon" aria-hidden="true">
            <img src="assets/images/Icons/mail.svg" alt="" />
          </div>
          <span class="benefit-text">{{'IDVERIFY_BENEFITS_02' | globalTranslate}}</span>
        </li>
        <li class="benefit-item">
          <div class="benefit-icon" aria-hidden="true">
            <img src="assets/images/Icons/arrows_icon.svg" alt="" />
          </div>
          <span class="benefit-text">{{'IDVERIFY_BENEFITS_03' | globalTranslate}}</span>
        </li>
        <li class="benefit-item">
          <div class="benefit-icon" aria-hidden="true">
            <img src="assets/images/Icons/documents_icon.svg" alt="" />
          </div>
          <span class="benefit-text">{{'IDVERIFY_BENEFITS_04' | globalTranslate}}</span>
        </li>
      </ul>
      <div class="modal-footer flex-column">
         <div>
        <button type="button" class="btn d-grid btn-secondary verify_button" aria-label="Verify my identity" (click)="verifyIdentity()">{{ 'RIDP_BTN' | globalTranslate }}</button>
      </div>
      <p class="dashboard-link-wrapper">
        <a  tabindex="0" class="action-link" (click)="onGoToDashboard()"><strong>{{ 'RIDP_DASHBOARD_LINK_1' | globalTranslate }}</strong></a>
      </p>
      </div>
    </div>
  </div>
</div>
